export function getSuffix(locale: string, env?: string): string {
  const localeMap = {
    'id': 'shopee.co.id',
    'my': 'shopee.com.my',
    'ph': 'shopee.ph',
    'tw': 'shopee.tw',
    'th': 'shopee.co.th',
    'vn': 'shopee.vn',
    'sg': 'shopee.sg',
    'cn': 'shopee.cn',
    'br': 'shopee.com.br',
    'mx': 'shopee.com.mx',
    'cl': 'shopee.cl',
    'co': 'shopee.com.co',
    'ar': 'shopee.com.ar',
    'pl': 'shopee.pl',
    'es': 'shopee.es',
    'fr': 'shopee.fr',
    'in': 'shopee.in',
  };

  if (env && env !== 'live') {
    // @ts-ignore
    return env + '.' + localeMap[locale];
  }
  // @ts-ignore
  return localeMap[locale];
}


export function getRegionSuffix(locale: string): string {
  const localeMap = {
    id: 'co.id',
    my: 'com.my',
    ph: 'ph',
    tw: 'tw',
    th: 'co.th',
    vn: 'vn',
    sg: 'sg',
    cn: 'cn',
    br: 'com.br',
    mx: 'com.mx',
    cl: 'cl',
    co: 'com.co',
    ar: 'com.ar',
    pl: 'pl',
    es: 'es',
    fr: 'fr',
    in: 'in',
  };
  // @ts-ignore
  return localeMap[locale];
}


export function getHostByRegion(locale: string, host: string, env?: string): string {
  const localeMap = {
    id: 'co.id',
    my: 'com.my',
    ph: 'ph',
    tw: 'tw',
    th: 'co.th',
    vn: 'vn',
    sg: 'sg',
    cn: 'cn',
    br: 'com.br',
    mx: 'com.mx',
    cl: 'cl',
    co: 'com.co',
    ar: 'com.ar',
    pl: 'pl',
    es: 'es',
    fr: 'fr',
    in: 'in',
  };
  if (env && env !== 'live') {
    // @ts-ignore
    return env + '.' + host + '.' + localeMap[locale];
  }
  // @ts-ignore
  return host + '.' + localeMap[locale];
}

